module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/ear-e2ee7145725ba4a0a5d4b4fc0cf550d4.png";